
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FilterName, FilterCollection } from '@/stores/filter.store';
import ResetButton from '@/components/buttons/ResetButton.vue';
import ToggleButton from '@/ui-components/ToggleButton.vue';
import { FormattedScoring, SCORINGS } from '@/helpers/scoring-helper';
import { CollectionType } from '../../enums/collection-type';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

const Filter = namespace('filter');

@Component({
	name: 'FilterRating',
	components: { ResetButton, ToggleButton },
})
export default class FilterRating extends Vue {
	@Prop() collectionType: CollectionType;
	@Prop() currentFilters: FilterCollection;

	@Filter.Action setFilterValue: (payload: { filterName: FilterName; filterValue: any }) => void;

	get scorings(): FormattedScoring[] {
		const scoringFilters = this.currentFilters.scoring_filter_types;
		return SCORINGS.filter(scoring => scoring.filterDisplay).map(scoring => {
			const value =
				scoringFilters && scoringFilters[scoring.provider]
					? scoringFilters[scoring.provider].min_scoring_value
					: 0;
			return {
				...scoring,
				value: this.round(value),
			};
		});
	}

	/**
	 * the range slider has changed and needs to update the store as well.
	 */
	changed(scoring: FormattedScoring, evt: any) {
		let value = evt.target?.value as number | undefined;
		if (value === undefined) {
			return;
		}
		if (value === scoring.value) {
			return;
		}
		value = this.round(value);
		const filterValue = {
			...this.currentFilters.scoring_filter_types,
			[scoring.provider]: { min_scoring_value: value },
		};
		if (value === scoring.min) {
			delete (filterValue as any)[scoring.provider];
		}
		this.setFilterValue({
			filterName: 'scoring_filter_types',
			filterValue: Object.keys(filterValue).length ? filterValue : null,
		});

		// Tracking
		TrackingHelper.trackEvent('userinteraction', { action: 'filter_toggled', label: 'scoring_filter_types' });
	}

	private round(rating: number) {
		return Math.round(rating * 10) / 10;
	}
	/**
	 * This functions updates the pin on the slider
	 *
	 * @param {any} event - the event that gets fired
	 * @param {string} sliderName - the name of the slider
	 *
	 */
	updatePin(event: any, sliderName: string): void {
		const sliderPin = (this.$refs as any)[`range-${sliderName}`][0].shadowRoot.querySelector('.range-pin');
		if (sliderPin) {
			sliderPin.textContent = this.round(event.detail.value);
		}
	}
}
